(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nestful-announcement"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nestful-announcement'))customElements.define('nestful-announcement',class extends HTMLElement{
 connectedCallback(){
  this.items=[...this.querySelectorAll('.nf-notice__item')];this.index=0;this.paused=false;this.mobile=matchMedia('(max-width:749px)');this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.events=new AbortController();const options={signal:this.events.signal};
  this.addEventListener('mouseenter',()=>{this.hover=true;this.sync()},options);this.addEventListener('mouseleave',()=>{this.hover=false;this.sync()},options);
  this.addEventListener('focusin',()=>{this.focused=true;this.sync()},options);this.addEventListener('focusout',()=>{this.focused=false;this.sync()},options);
  document.addEventListener('visibilitychange',()=>this.sync(),options);this.mobile.addEventListener('change',()=>this.sync(),options);this.reduced.addEventListener('change',()=>this.sync(),options);
  this.addEventListener('shopify:block:select',event=>{const index=this.items.indexOf(event.target.closest('.nf-notice__item'));if(index>=0){this.index=index;this.paused=true;this.sync()}},options);
  this.classList.add('is-ready');this.sync();
 }
 sync(){
  clearInterval(this.timer);const rotating=this.mobile.matches&&!this.reduced.matches&&this.items.length>1;
  this.classList.toggle('is-ready',!this.reduced.matches||!this.mobile.matches);
  this.items.forEach((item,i)=>item.classList.toggle('is-current',i===this.index));
  if(rotating&&!this.paused&&!this.hover&&!this.focused&&!document.hidden)this.timer=setInterval(()=>{this.index=(this.index+1)%this.items.length;this.items.forEach((item,i)=>item.classList.toggle('is-current',i===this.index))},Number(this.dataset.speed)||5000);
 }
 disconnectedCallback(){clearInterval(this.timer);this.events?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nestful-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nestful-collection')) customElements.define('nestful-collection', class extends HTMLElement {
  async connectedCallback() {
    if(this.initialized)return;this.initialized=true;
    this.grid=this.querySelector('.nf-collection-grid');this.form=this.querySelector('.nf-filter-form');this.dialog=this.querySelector('dialog');this.limit=24;this.currency=this.dataset.currency||'EUR';this.money=new Intl.NumberFormat(this.dataset.locale||'de',{style:'currency',currency:this.currency});this.items=[...this.grid.children];
    this.querySelector('.nf-sort-form select').addEventListener('change',e=>{const u=new URL(location.href);u.searchParams.set('sort_by',e.target.value);u.searchParams.delete('page');location.href=u.href;});
    this.addEventListener('click',e=>this.cardAction(e));
    let touchStart;this.addEventListener('touchstart',e=>{const m=e.target.closest('.nf-list-media');if(m)touchStart={x:e.touches[0].clientX,y:e.touches[0].clientY,m};},{passive:true});
    this.addEventListener('touchend',e=>{if(!touchStart)return;const dx=e.changedTouches[0].clientX-touchStart.x,dy=e.changedTouches[0].clientY-touchStart.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5){this.showImage(touchStart.m,dx<0?1:-1);this.swipedAt=Date.now();}touchStart=null;},{passive:true});
    this.addEventListener('click',e=>{if(Date.now()-(this.swipedAt||0)<400&&e.target.closest('.nf-list-image-link'))e.preventDefault();},true);
    let next=this.querySelector('[data-next-page]')?.href;
    try {
      while(next){const u=new URL(next,location.href);u.searchParams.set('section_id',this.dataset.section);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);const response=await fetch(u);if(!response.ok)throw Error('load');const doc=new DOMParser().parseFromString(await response.text(),'text/html');const cards=[...doc.querySelectorAll('.nf-list-item')];const seen=new Set(this.items.map(x=>x.dataset.id));for(const card of cards){if(!seen.has(card.dataset.id)){this.grid.append(card);this.items.push(card);}}next=doc.querySelector('[data-next-page]')?.getAttribute('href');if(next)next=new URL(next,u).href;}
    } catch {return;}
    this.facets={color:new Set(),size:new Set(),material:new Set(),capacity:new Set(),features:new Set()};
    this.items.forEach(item=>{const d=item.dataset;const options=JSON.parse(d.options||'[]');const attrs={color:[],size:[],material:[],capacity:[],features:[]};for(const o of options){const name=o.name.toLowerCase();const values=o.values.map(v=>typeof v==='string'?v:v.name||String(v));if(/farbe|color|colour/.test(name))attrs.color.push(...values);if(/größe|breite|size/.test(name))attrs.size.push(...values);}
      const rows=(d.specs||'').split('\n');for(const row of rows){const i=row.indexOf(':');if(i<0)continue;const key=row.slice(0,i).trim().toLowerCase(),val=row.slice(i+1).trim();if(key==='material'&&val.length<100)attrs.material.push(val);}
      const capacity=d.title.match(/(\d+)\s*kg/i);if(capacity)attrs.capacity.push(capacity[1]+' kg');
      const text=(d.title+' '+d.features).toLowerCase();for(const [label,pattern] of [['Mit Rollen',/mit rollen|rollbar|360°/],['Mit Ablage',/mit ablage|ablagen|holzablagen/],['Höhenverstellbar',/höhenverstellbar/],['Mit Sitzbank',/sitzbank/],['Mit Spiegel',/mit spiegel/],['Mit Beleuchtung',/beleuchtung|led|mit licht/],['Mit Schubladen',/schubladen/]])if(pattern.test(text))attrs.features.push(label);
      item.nfAttributes=attrs;Object.entries(attrs).forEach(([k,values])=>values.forEach(v=>this.facets[k].add(v)));
    });
    const labels={color:'Farbe',size:'Größe',material:'Material',capacity:'Belastbarkeit',features:'Ausstattung'};const holder=this.querySelector('[data-dynamic-filters]');
    for(const [name,values] of Object.entries(this.facets)){if(values.size<2)continue;const field=document.createElement('fieldset'),legend=document.createElement('legend');legend.textContent=labels[name];field.append(legend);[...values].sort((a,b)=>a.localeCompare(b,'de',{numeric:true})).forEach(value=>{const label=document.createElement('label');label.className='nf-check';const input=document.createElement('input');input.type='checkbox';input.name=name;input.value=value;label.append(input,document.createTextNode(value));field.append(label);});holder.append(field);}
    this.querySelector('[data-open-filters]').hidden=this.items.length===0;this.querySelector('[data-open-filters]').addEventListener('click',()=>{this.dialog.showModal();this.previewCount();});this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left)this.dialog.close();}});
    this.form.addEventListener('submit',e=>{e.preventDefault();this.limit=24;this.update(true);this.dialog.close();});this.form.addEventListener('input',()=>this.previewCount());this.form.addEventListener('reset',()=>{setTimeout(()=>{this.limit=24;this.update(true);},0);});this.querySelector('[data-load-more]').addEventListener('click',()=>{this.limit+=24;this.update(true);});
    this.restore();window.addEventListener('popstate',()=>{this.restore();this.update(false);});this.dataset.ready='true';this.update(false);
  }
  selection(){const o={};for(const [k,v] of new FormData(this.form)){if(v!=='')(o[k]??=[]).push(v);}return o;}
  matching(){const s=this.selection();return this.items.filter(item=>{const p=Number(item.dataset.price)/100;if(s.available&&item.dataset.available!=='true')return false;if(s.min&&p<Number(s.min[0]))return false;if(s.max&&p>Number(s.max[0]))return false;return Object.entries(item.nfAttributes).every(([k,values])=>!s[k]||s[k].some(v=>values.includes(v)));});}
  previewCount(){this.querySelector('[data-preview-count]').textContent='('+this.matching().length+')';}
  restore(){const h=new URLSearchParams(location.hash.replace(/^#/,''));for(const el of this.form.elements){if(!el.name)continue;if(el.type==='checkbox')el.checked=h.getAll('nf_'+el.name).includes(el.value);else if(el.type==='number')el.value=h.get('nf_'+el.name)||'';}this.limit=Math.max(24,Math.min(this.items.length,Number(h.get('nf_limit'))||24));}
  update(save){const matches=this.matching(),visible=new Set(matches.slice(0,this.limit));this.items.forEach(x=>x.hidden=!visible.has(x));this.querySelector('[data-results]').textContent=matches.length;this.querySelector('[data-no-results]').hidden=matches.length>0||this.items.length===0;this.querySelector('[data-load-more]').hidden=matches.length<=this.limit;this.querySelector('[data-progress]').textContent=matches.length?`${Math.min(this.limit,matches.length)} / ${matches.length} angezeigt`:'';const selection=this.selection(),active=this.querySelector('.nf-active-filters');active.replaceChildren();let count=0;
    for(const [name,values] of Object.entries(selection))for(const value of values){count++;const b=document.createElement('button');b.type='button';b.textContent=(name==='available'?'Verfügbar':name==='min'?'Ab '+this.money.format(value):name==='max'?'Bis '+this.money.format(value):value)+' ×';b.setAttribute('aria-label','Filter entfernen: '+b.textContent);b.onclick=()=>{for(const el of this.form.elements){if(el.name===name&&el.value===value){if(el.type==='checkbox')el.checked=false;else el.value='';}}this.limit=24;this.update(true);};active.append(b);}active.hidden=count===0;this.querySelector('[data-filter-count]').textContent=count?'('+count+')':'';this.previewCount();
    if(save){const u=new URL(location.href),h=new URLSearchParams();for(const [k,values] of Object.entries(selection))values.forEach(v=>h.append('nf_'+k,v));h.set('nf_limit',this.limit);u.hash=h.toString();history.replaceState(null,'',u);}
  }
  showImage(media,step){const images=[...media.querySelectorAll('.nf-list-photo')];if(!images.length)return;let index=(Number(media.dataset.image||0)+step+images.length)%images.length;media.dataset.image=index;images.forEach((im,i)=>im.style.display=i===index?'block':'none');const counter=media.querySelector('[data-image-count]');if(counter)counter.textContent=`${index+1} / ${images.length}`;}
  cardAction(e){const step=e.target.closest('[data-image-step]');if(step){this.showImage(step.closest('.nf-list-media'),Number(step.dataset.imageStep));return;}const swatch=e.target.closest('.nf-list-swatch');if(!swatch)return;const card=swatch.closest('.nf-list-card'),data=swatch.dataset;card.querySelectorAll('.nf-list-swatch').forEach(x=>x.setAttribute('aria-pressed',String(x===swatch)));card.querySelector('.nf-list-color-name').textContent=data.name;const image=card.querySelector('.nf-list-photo');image.removeAttribute('srcset');image.src=data.photo;this.showImage(card.querySelector('.nf-list-media'),-Number(card.querySelector('.nf-list-media').dataset.image||0));for(const link of card.querySelectorAll('a')){const u=new URL(link.href);u.searchParams.set('variant',data.variant);link.href=u.href;}card.querySelector('[data-current-price]').textContent=this.money.format(Number(data.price)/100);const compare=card.querySelector('[data-compare-price]');compare.textContent=this.money.format(Number(data.compare)/100);compare.hidden=Number(data.compare)<=Number(data.price);let badge=card.querySelector('.nf-list-badge');if(!badge){badge=document.createElement('span');badge.className='nf-list-badge';card.querySelector('.nf-list-media').append(badge);}badge.hidden=false;if(data.available!=='true')badge.textContent='Ausverkauft';else if(Number(data.compare)>Number(data.price))badge.textContent='Spare '+this.money.format((Number(data.compare)-Number(data.price))/100).replace(/,00(?=\s|€)/,'');else badge.hidden=true;}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nestful-footer"]) return;
  try {
    
document.addEventListener('click',event=>{
 const link=event.target.closest('[data-nf-cookie-settings]');
 if(!link)return;
 if(window.Pandectes?.hasInitialized&&typeof window.Pandectes.fn?.openPreferences==='function'){
  try{window.Pandectes.fn.openPreferences();event.preventDefault()}catch(error){}
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nestful-service"]) return;
  try {
    
const initializeNestfulContact=()=>{const field=document.getElementById('ServiceTopic');if(!field)return;const topic=new URLSearchParams(location.search).get('topic');if([...field.options].some(option=>option.value===topic))field.value=topic;};
initializeNestfulContact();document.addEventListener('shopify:section:load',initializeNestfulContact);

  } catch(e) { console.error(e); }
})();
})();
